// ForJWT Auth
import {
  useJWTAuth,
  useJWTAuthActions,
} from '../services/auth/jwt-auth/JWTAuthProvider';
import {getUserFromJwtAuth} from './Utils';

export const useAuthUser = () => {
  const {user, isAuthenticated, isLoading} = useJWTAuth();
  return {
    isLoading,
    isAuthenticated,
    user: getUserFromJwtAuth(user),
  };
};

export const useAuthMethod = () => {
  const {signInUser, setJWTData, logout, getPublicKey} = useJWTAuthActions();

  return {
    getPublicKey,
    signInUser,
    setJWTData,
    logout,
  };
};
